import { render } from "./member-list.vue?vue&type=template&id=87509992&scoped=true"
import script from "./member-list.vue?vue&type=script&lang=js"
export * from "./member-list.vue?vue&type=script&lang=js"

import "./member-list.vue?vue&type=style&index=0&id=87509992&scoped=true&lang=less"

import exportComponent from "/home/www/jenkins/jenkins_home/workspace/yizhige_production/yizhige_admin_pro/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-87509992"]])

export default __exports__